import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import { createUIDefinition } from '../default-task-definition'

export default createUIDefinition({
    taskName: taskName.CALL_CUSTOMER,
    widgetList: [
        {
            component: processUI.LOW_NPS_REASON_WIDGET_CONTAINER,
        },
    ],
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/escalation/call-customer.js